import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { MobileNav } from '../components/MobileNav';
export function DecodeLanding() {
  return <>
      <Helmet data-id="element-963">
        <title data-id="element-964">Start a Decode | Lazy Monk Labs</title>
        <meta name="description" content="A structural read of how your system operates under pressure, responsibility, and visibility." data-id="element-965" />
        <meta name="robots" content="index, follow" data-id="element-966" />
        <link rel="canonical" href="https://lazymonklabs.com/decode" data-id="element-967" />
      </Helmet>

      <main className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] selection:bg-white selection:text-black" data-id="element-968">
        <MobileNav data-id="element-969" />

        {/* 1. HERO */}
        <section className="min-h-[85vh] flex flex-col justify-center px-6 pt-20 pb-16" data-id="element-970">
          <div className="max-w-3xl mx-auto w-full space-y-10" data-id="element-971">
            <h1 className="text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-[#F5F5F5] tracking-tight" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-972">
              You've noticed the pattern.
              <br data-id="element-973" />
              This names it.
            </h1>

            <p className="text-lg md:text-xl text-gray-400 leading-[1.6] font-light max-w-2xl" data-id="element-974">
              A Decode is a structural read of how your system operates under
              pressure, responsibility, and visibility.
            </p>

            <div className="pt-8" data-id="element-975">
              <a href="https://app.lazymonklabs.com" className="px-8 py-3 border border-[#F5F5F5] text-[#F5F5F5] text-sm uppercase tracking-widest font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors rounded-sm inline-block" data-id="element-976">
                Start Your Decode →
              </a>
            </div>
          </div>
        </section>

        {/* 2. WHAT IT IS */}
        <section className="py-20 md:py-28 px-6 border-t border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-977">
          <div className="max-w-3xl mx-auto space-y-12" data-id="element-978">
            <p className="text-xl md:text-2xl text-[#F5F5F5] leading-relaxed font-light" data-id="element-979">
              A Decode does three things:
            </p>

            <div className="space-y-6 pl-4 border-l border-[#2B2B2B]" data-id="element-980">
              <p className="text-lg md:text-xl text-gray-400 font-light" data-id="element-981">
                1. Names your core operating pattern
              </p>
              <p className="text-lg md:text-xl text-gray-400 font-light" data-id="element-982">
                2. Shows the tension inside it
              </p>
              <p className="text-lg md:text-xl text-gray-400 font-light" data-id="element-983">
                3. Reveals the cost of repeating it
              </p>
            </div>

            <p className="text-sm text-gray-600 pt-4" data-id="element-984">
              No metaphysics. No philosophy. Just structure.
            </p>
          </div>
        </section>

        {/* 3. REAL EXAMPLE */}
        <section className="py-20 md:py-28 px-6 border-t border-[#2B2B2B] bg-[#111214]" data-id="element-985">
          <div className="max-w-3xl mx-auto" data-id="element-986">
            <p className="text-xs font-mono text-gray-600 uppercase tracking-widest mb-10" data-id="element-987">
              Example
            </p>

            <div className="space-y-12" data-id="element-988">
              <p className="text-xl md:text-2xl text-[#F5F5F5] leading-snug" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-989">
                You don't hesitate because you're unsure. You hesitate because
                you don't trust unfinished thinking.
              </p>

              <div className="space-y-4" data-id="element-990">
                <p className="text-lg text-gray-400 font-light" data-id="element-991">
                  This is what a Decode does.
                </p>
                <p className="text-lg text-gray-400 font-light" data-id="element-992">
                  It isolates the pattern beneath your decisions.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 4. WHO IT'S FOR */}
        <section className="py-20 md:py-28 px-6 border-t border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-993">
          <div className="max-w-3xl mx-auto space-y-12" data-id="element-994">
            <h2 className="text-3xl md:text-4xl text-[#F5F5F5]" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-995">
              Who this is for
            </h2>

            <div className="space-y-6" data-id="element-996">
              <p className="text-lg md:text-xl text-gray-400 font-light" data-id="element-997">
                People who replay decisions after they've already made them.
              </p>
              <p className="text-lg md:text-xl text-gray-400 font-light" data-id="element-998">
                People who feel responsible even when no one asked them to.
              </p>
              <p className="text-lg md:text-xl text-gray-400 font-light" data-id="element-999">
                People who sense the friction before they can explain it.
              </p>
              <p className="text-lg md:text-xl text-gray-400 font-light" data-id="element-1000">
                People who want to see the pattern, not be told what to do.
              </p>
            </div>
          </div>
        </section>

        {/* 5. WHAT IT IS NOT */}
        <section className="py-20 md:py-28 px-6 border-t border-[#2B2B2B] bg-[#111214]" data-id="element-1001">
          <div className="max-w-3xl mx-auto space-y-12" data-id="element-1002">
            <h2 className="text-3xl md:text-4xl text-[#F5F5F5]" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-1003">
              What this is not
            </h2>

            <div className="space-y-4" data-id="element-1004">
              <p className="text-base text-gray-500" data-id="element-1005">• Not astrology content</p>
              <p className="text-base text-gray-500" data-id="element-1006">
                • Not personality typing
              </p>
              <p className="text-base text-gray-500" data-id="element-1007">• Not coaching</p>
              <p className="text-base text-gray-500" data-id="element-1008">• Not predictions</p>
              <p className="text-base text-gray-500" data-id="element-1009">• Not motivation</p>
            </div>

            <p className="text-xl text-[#F5F5F5] pt-6 border-t border-[#2B2B2B]" data-id="element-1010">
              Just pattern recognition.
            </p>
          </div>
        </section>

        {/* 6. FOUNDER FRAMING */}
        <section className="py-20 md:py-28 px-6 border-t border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-1011">
          <div className="max-w-3xl mx-auto" data-id="element-1012">
            <p className="text-lg md:text-xl text-gray-400 font-light leading-relaxed" data-id="element-1013">
              Built by someone obsessed with structural patterns in behavior and
              decision-making.
            </p>
          </div>
        </section>

        {/* 7. FINAL CTA */}
        <section className="py-24 md:py-32 px-6 border-t border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-1014">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1015">
            <a href="https://app.lazymonklabs.com" className="px-8 py-3 border border-[#F5F5F5] text-[#F5F5F5] text-sm uppercase tracking-widest font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors rounded-sm inline-block" data-id="element-1016">
              Start Your Decode →
            </a>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="py-12 px-6 bg-[#0A0A0A] border-t border-[#2B2B2B]" data-id="element-1017">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8" data-id="element-1018">
            <Link to="/" className="text-gray-500 hover:text-[#F5F5F5] transition-colors text-sm" data-id="element-1019">
              Lazy Monk Labs
            </Link>
            <a href="mailto:anish@lazymonklabs.com" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors" data-id="element-1020">
              Contact
            </a>
          </div>
        </footer>
      </main>
    </>;
}